module.exports = __webpack_public_path__ + "img/more-icon.dca8767b.svg";